var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.3 146.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M232.7 90.2H285c23.3 0 25.2-33.3 4.3-37.5-3.3-15.2-23.3-20-33.3-7.6-7.6-1.9-15.2 1.4-20 7.6-11.4-2.4-22.3 6.7-22.3 18.5 0 10.5 8.6 19 19 19zm3.8-27.5c1 .5 2.4.5 3.8 0s2.4-1.4 2.9-2.9c1.9-4.8 7.6-7.6 12.8-4.8 1 .5 2.4.5 3.8 0s2.4-1.4 2.9-2.4c4.3-9 17.6-5.7 17.6 4.3 0 1 0 1.9 1 2.9 1 1.4 2.4 2.4 3.8 2.4 12.4 0 12.4 19 0 19h-52.3c-5.2 0-9.5-4.3-9.5-9.5-.1-7.6 7.1-11.9 13.2-9zM21.4 96H58c10 0 17.6-8.1 17.6-17.6S68 60.8 58 60.8c0-11.9-10-21.4-21.9-21.4-12.8 0-22.3 10.5-21.9 22.8-6.2 2.4-10.5 9-10.5 16.2.2 10 8.2 17.6 17.7 17.6zm-.9-25.7c2.9-.5 4.8-3.3 3.8-5.7-1.9-8.6 4.3-16.2 12.4-16.2S51.4 56.5 48.6 65c-1.4 3.8 2.9 7.6 6.7 5.7 1-.5 2.4-1 3.3-1 4.8 0 8.1 3.8 8.1 8.1s-3.8 8.1-8.1 8.1H21.4c-4.8 0-8.1-3.8-8.1-8.1.1-3.7 3.4-7 7.2-7.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6eedf725ad6461eb904bdbdc74271521.svg";
export { ForwardRef as ReactComponent };